
import { CardHeader, CardTitle } from "@/components/ui/card";

export const SignInHeader = () => {
  return (
    <CardHeader className="space-y-1">
      <CardTitle className="text-3xl font-bold text-center bg-gradient-to-r from-primary/80 to-primary bg-clip-text text-transparent">
        Medicace
      </CardTitle>
      <p className="text-center text-muted-foreground">
        Connectez-vous à votre compte
      </p>
    </CardHeader>
  );
};
